<wiz-vgroup #filterContainer width="100%" height="100%" verticalAlign="center" gap="0" class="basicInput">
  <wiz-hgroup width="100%" verticalAlign="center">
    <wiz-label #filterNameLbl width="140px"></wiz-label>
    <wiz-icon [hidden]="!data.hasFilter" style="cursor: pointer" (click)="clearFilter($event)">clear-filters</wiz-icon>
  </wiz-hgroup>
  <wiz-hgroup width="100%" height="20px" verticalAlign="center">
    <wiz-label
      #filterContentLbl
      [wizTextBehavior]="'truncate'"
      class="wiz-component-field"
      width="140px"
      height="100%"
      style="font-weight: normal;"
    ></wiz-label>
    <wiz-icon #btshowPop style="cursor: pointer" (click)="showHidePop()">arrow-down</wiz-icon>
  </wiz-hgroup>
  <span #block width="1px"></span>
</wiz-vgroup>
